require("./qf/predictiveSearch");
require("./qf/LocalizationForm");

import { CartQf } from './qf/cart';
import { GlobalListeners } from './qf/global_listeners';
import { WishlistObjectQf } from './qf/wishlistAsObject';
import { ModalController } from './qf/ModalController';
import { LoadMore } from './qf/loadMore';
import { QfForm } from './qf/formSubmission';


window.cart = new CartQf();
window.globalListeners = new GlobalListeners();
window.wishlist = new WishlistObjectQf();
window.modalController = new ModalController()
window.LoadMore = LoadMore;
window.QfForm = QfForm;

const swatchActivate = (e)=>{
    var target = e.target.closest('.variant-wrapper')
    var card = target.closest('.product-card')
    card.querySelectorAll('.variant-wrapper').forEach((node)=>{
        node.classList.remove('active')
    })
    target.classList.add('active')
    var img_target = card.querySelector('.product-image img')
    var hover_img_target = card.querySelector('.product-image .image-hover')
    img_target.removeAttribute('srcset')
    hover_img_target?.removeAttribute('srcset')
    img_target.setAttribute('src',target.getAttribute('data-image'))
    hover_img_target?.setAttribute('src',target.getAttribute('data-hover'))
    card.setAttribute('href',target.getAttribute('data-href'))
    card.querySelector('.price').innerHTML = target.getAttribute('data-price-show')
    card.querySelector('.compare_at_price').innerHTML = target.getAttribute('data-compare-show')
    var price = parseInt(target.getAttribute('data-price'))
    var compare = parseInt(target.getAttribute('data-compare'))
    if(price < compare){
        card.querySelector('.price').classList.add('sale')
        card.querySelector('.compare_at_price').classList.add('active')
    }
    else{
        card.querySelector('.price').classList.remove('sale')
        card.querySelector('.compare_at_price').classList.remove('active')
    }
}

const initSwatches = ()=>{
    document.querySelectorAll('.product-card .swatch-select:not(.initialised)').forEach((node)=>{
        node.querySelectorAll('.variant-wrapper').forEach((node)=>{
            node.addEventListener('mouseenter',(e)=>{
                swatchActivate(e)
            })
            node.addEventListener('click',(e)=>{
                e.preventDefault()
                e.stopPropagation()
                swatchActivate(e)
            })
        })
        node.classList.add('initialised')
    })
}

document.addEventListener("DOMContentLoaded", () => {
    initSwatches()
})

document.addEventListener("shopify-wishlist:init-product-grid", () => {
    initSwatches()
})

document.addEventListener('search-done',()=>{
    initSwatches()
})

document.addEventListener('pagination-done',()=>{
    initSwatches()
})

document.addEventListener('recently-viewed-init',()=>{
    initSwatches()
})

document.querySelectorAll('.lang-selector').forEach((node)=>{
    node.addEventListener('change',(e)=>{
        e.target.closest('form').submit()
    })
})

document.addEventListener('click',(e)=>{
    var target = e.target.closest('.quick-view-modal .swatch-select .variant-wrapper')
    if(target != null){
        var handle = target.getAttribute('href')
        e.preventDefault()
        e.stopPropagation()
        if(handle != '#'){
            handle = handle.split('/').pop()
            window.globalListeners.openQuickView(null,handle)
        }
    }
})

document.addEventListener('quickview-init',(e)=>{
    window.wishlist.buttonCheck()
})

document.querySelector('body').addEventListener('click',(e)=>{
    if(e.target.closest('.lang-select-proxy-value') != null){
        e.target.closest('#localization_form').querySelector('.lang-select-proxy').classList.add('show')
    }
    else{
        document.querySelectorAll('.lang-select-proxy').forEach((node)=>{
            node.classList.remove('show')
        })
    }
})

document.querySelectorAll('.lang-select-proxy-value').forEach((node)=>{
    node.addEventListener('click',(e)=>{
        node.closest('#localization_form').querySelector('.lang-select-proxy').classList.toggle('show')
    })
})

document.querySelectorAll('.lang-select-proxy li').forEach((node)=>{
    node.addEventListener('click',(e)=>{
        node.closest('#localization_form').querySelector('select').value = node.getAttribute('data-value')
        node.closest('#localization_form').submit()
        document.querySelector('.lang-select-proxy').classList.toggle('show')
    })
})